module.exports = __webpack_public_path__ + "img/productBgImg7.a81b69e7.png";